
import { Dialog, Toast } from "vant";
import VueClipboard from "vue-clipboard2";
import { Component, Vue } from "vue-property-decorator";
import navBar from "@/components/navBar.vue";
import { purchaseDetail, sellDetail, orderCancel, orderDel } from "@/req/order";
import payModal from "../pay/index.vue";
Vue.use(VueClipboard);
@Component({
  components: {
    navBar,
    payModal,
  },
})
export default class Logout extends Vue {
  public price = "200.00";
  public time = 1800000;
  public rows: any = [];
  public rowsList: any = [];
  public mounted() {
    this.getOrderDetail();
  }
  public async getOrderDetail() {
    const str: any = this.$route.query;
    const obj = {
      order_id: str.id,
    };
    const res =
      str.type == 1 ? await purchaseDetail(obj) : await sellDetail(obj);
    if (res.code == 200) {
      this.rows = res.data;
      this.rowsList = res.data.commodity;
    }
  }
  public onCopy(e) {
    Toast("复制成功！");
  }
  public onError(e) {
    Toast("复制失败！");
  }
  public gopath() {
    this.$router.go(-1);
  }
  public dialogOrder(type) {
    let str = "";
    type
      ? (str = "确定要取消订单么，还差一步就成功了哟")
      : (str = "确认删除订单");
    Dialog.confirm({
      title: `${str}`,
    })
      .then(() => {
        type ? this.cancelOrder() : this.delOrder();
      })
      .catch(() => {
        Dialog.close();
      });
  }
  public async cancelOrder() {
    const res = await orderCancel({
      order_id: this.rows.id,
    });
    if (res.code == 200) {
      Toast(res.msg);
      this.$router.go(-1);
    }
  }
  public async delOrder() {
    const res = await orderDel({
      order_id: this.rows.id,
    });
    if (res.code == 200) {
      Toast(res.msg);
      this.$router.go(-1);
    }
  }
  public returmPrice(e) {
    e = e.toFixed(2);
    const splitPrice = e.split(".");
    // return e
    return `￥<span style="font-size: 22px;">${splitPrice[0]}</span>.${splitPrice[1]}`;
  }
  // 点击付款弹框
  public goPay(item) {
    const $payModal: any = this.$refs.payModal;
    $payModal.show(item, true);
  }
}
